import React, { type FC, memo, type RefObject } from "react";
import SectionWrapper from "./SectionWrapper";
import { CarConfigHighlightSection } from "../../../../utils/types/SectionTypes";
import styles from "../Highlights.module.scss";
import { getVisualForGradeImage } from "../../../../../../../common-deprecated/settings/utils/ccisSettingUtils";
import { useCarConfigSelector } from "../../../../redux/store";
import Text from "../../../../../shared-components/css-modules/lexus/atoms/Text";
import { CarConfigLabel } from "../../../../utils/labelUtils";

export type HeroProps = {
    sectionRef?: RefObject<HTMLElement>;
};

const Hero: FC<HeroProps> = ({ sectionRef }) => {
    const commonSettings = useCarConfigSelector((state) => state.commonSettings);
    const car = useCarConfigSelector((state) => state.car);
    const headerImageUrl = getVisualForGradeImage(
        commonSettings,
        car.model.id,
        car.grade.id,
        car.body.id,
        {
            type: "webp",
            padding: 700,
            bgImage: "hd-day-white",
            imageQuality: 100,
            srcSet: [
                { width: 1700, height: 800, padding: 700 },
                { width: 1000, height: 470, padding: 350 },
                { width: 500, height: 235, padding: 175 },
            ],
        },
        14,
    );
    return (
        <SectionWrapper sectionId={CarConfigHighlightSection.SectionHeader} sectionRef={sectionRef} wrap={false}>
            <header className={styles.header}>
                <img
                    {...headerImageUrl}
                    width="1700"
                    height="800"
                    sizes="(max-width: 500px) 500px, (max-width: 1000px) 1000px, 1700px"
                    className={styles.hero}
                    loading="eager"
                    alt=""
                    role="presentation"
                />
                <Text tag="h1" variant="apheleia-h2" className={styles.title}>
                    <CarConfigLabel
                        useHTML
                        label="carConfigHighlightsIconicFeatures"
                        params={{ model: car.model.webtitleSectionName }}
                    />
                </Text>
            </header>
        </SectionWrapper>
    );
};

export default memo(Hero);
